import { apiV2Client } from '../../../services/apiClient';
import { AssessmentReportResponse } from '../models/assessmentReport';

type GetAssessmentReportParams = {
  orgId: string;
  assessmentId: string;
  since?: number; // This value will filter future reports to only include responses after this date
  until?: number; // This value will filter future reports to only include responses before this date
};

export const getAssessmentReport = ({
  orgId,
  assessmentId,
  since,
  until,
}: GetAssessmentReportParams): Promise<AssessmentReportResponse> => {
  return apiV2Client
    .get<AssessmentReportResponse>(`/assessment/report/${orgId}/${assessmentId}`, {
      params: {
        since,
        until,
      },
    })
    .then(({ data }) => data);
};
